import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../redux/action';
import FaqDetailContentSC, { OtherFaqsSC, DetailSC } from './faq-detail-content.styled';
import { withRouter } from 'react-router-dom';
import { useState } from 'react';
import Button from '../ui/button';

const _FaqDetailContent = ({
  faqCategories,
  allFaqs,
  getFAQsAnswer,
  faqAnswer,
  match,
  history,
}) => {
  const uriFaqId = match.params.id;
  const [allCategoryFaqs, setAllCategoryFaqs] = useState([]);
  const [singleFaqQuestion, setSingleFaqQuestion] = useState({});

  useEffect(() => {
    getFAQsAnswer(uriFaqId);
  }, [uriFaqId, getFAQsAnswer]);

  useEffect(() => {
    const singleFaq = allFaqs.filter((item) => item.id === Number(uriFaqId))[0];
    const categoryFaqs = allFaqs.filter((item) => item.categoryId === singleFaq.categoryId);
    setAllCategoryFaqs(categoryFaqs);
    setSingleFaqQuestion(singleFaq);
  }, [uriFaqId, allFaqs]);

  const handleFaqClick = (faqId) => {
    history.push(`/faq/detail/${faqId}`);
  };

  return (
    <FaqDetailContentSC>
      <OtherFaqsSC>
        {allCategoryFaqs.map((faq) => {
          return (
            <Button
              type="LINK"
              key={faq.id}
              onClick={() => handleFaqClick(faq.id)}
              className={faq.id === Number(uriFaqId) ? 'active' : null}
            >
              {faq.question}
            </Button>
          );
        })}
      </OtherFaqsSC>
      <DetailSC>
        <span className="answer-headline">
          {singleFaqQuestion !== undefined ? singleFaqQuestion.question : null}
        </span>
        <div dangerouslySetInnerHTML={{ __html: faqAnswer.answer }} />
      </DetailSC>
    </FaqDetailContentSC>
  );
};

const mapStateToProps = (state) => {
  return {
    faqCategories: state.faq.categories,
    allFaqs: state.faq.questions,
    faqAnswer: state.faq.answer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getFAQsAnswer: ActionCreators.getFAQsAnswer,
    },
    dispatch
  );
};

const FaqDetailContent = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(_FaqDetailContent)
);

export default FaqDetailContent;
